enum SubmitMonthlyPricingResultOutputState {
	SUCCESS = 'SUCCESS',
	FAILED = 'FAILED'
}

export default SubmitMonthlyPricingResultOutputState;
